import { Signal } from "@suse-o11y/signal";
import { usePermanent } from "@suse-o11y/use-permanent";
import React from "react";

import { SouthPaneContext, type SouthPaneState } from "./_context";

export const SouthPaneProvider: React.FC<
	React.PropsWithChildren<{
		state?: SouthPaneState;
	}>
> = ({ state, children }) => {
	const fallback = usePermanent<SouthPaneState>(() => ({
		isOpen: Signal(true),
	}));

	return <SouthPaneContext.Provider value={state ?? fallback}>{children}</SouthPaneContext.Provider>;
};
